/* ==========================================================================
   SearcherFlightHotel > Calendar
   ========================================================================== */

/* Modules */
const CalendarClient = require('@bluekiri/alexandria-contrib-components/components/calendar/client/js');
const transactions = require('../transactions');
const helpers = require('../../../../../helpers/calendar');

const storedOperatives = {};

function initCalendar(selector, configuration, instance) {
    const calendar = CalendarClient(selector, {
        ...configuration,
        fp: {
            showMonths: 2,
            ariaDateFormat: 'Y/m/d',
            minDate: new Date().fp_incr(instance.element.dataset.releaseDays),
            ...configuration.fp,
            // eslint-disable-next-line max-params
            onDayCreate: (dObj, dStr, fp, dayElem) => {
                instance.onCalendarDayCreate(dObj, dStr, fp, dayElem);
            }
        },
        onChange: [
            function onChange() {
                instance.onChangeDisableDaysCalendar(instance);
                const selectedDay = this.fp.selectedDateElem;
                // disabled day, you can't select the same date departure than return
                selectedDay.classList.add('flatpickr-disabled', 'disabled');
                selectedDay.blur();
            }
        ]
    });

    if (instance.element.dataset.defaultdates) {
        const dates = JSON.parse(instance.element.dataset.defaultdates).map(date => new Date(date));
        calendar.fp.setDate(dates);
    }

    calendar.currentDates = calendar.get();
    calendar.fp.config.onClose = [
        () => {
            if (calendar.get().length === 0 || calendar.get().length === 1) {
                calendar.input.setActive();
                calendar.setDate(calendar.currentDates);
            }
            calendar.currentDates = calendar.get();
        }
    ];

    if (instance.config.disableDays) instance.setDisableDays(instance.config.disableDays);

    return calendar;
}

document.addEventListener('routeChangeOperative', e => {
    if (retrieveCachedOperative(e.detail.instance) === undefined) {
        transactions.getFlightOperative(e.detail.instance, storeCachedOperative);
    } else {
        helpers.setFirstAvailableDates(e.detail.instance, {
            retrieveCachedOperative,
            getFilteredDates,
            getParsedDates
        });
        enableCalendarDates(e.detail.instance);
    }
});

document.addEventListener('activateOperative', e => {
    helpers.setFirstAvailableDates(e.detail.instance, {
        retrieveCachedOperative,
        getFilteredDates,
        getParsedDates
    });
    enableCalendarDates(e.detail.instance);
});

function getCalendarElementOnOpen(instance) {
    const rootNode = instance.element.getRootNode();
    const searcher = rootNode.getElementsByClassName('searcher--flight-hotel')[0];
    const calendar = searcher.getElementsByClassName('flatpickr-calendar')[0];

    if (calendar !== undefined) {
        return calendar.getElementsByClassName('flatpickr-days')[0];
    }
    return undefined;
}

function enableCalendarDates(instance) {
    const operative = retrieveCachedOperative(instance);
    if (operative !== undefined) {
        if (isCalendarFirstClick(instance)) {
            if (operative.checkouts !== undefined) {
                disableDates(getDisabledDays(operative.checkouts), getCalendarElementOnOpen(instance));
            }
        } else if (operative.checkins !== undefined) {
            disableDates(getDisabledDays(operative.checkins), getCalendarElementOnOpen(instance));
        }
    }
}

function disableDates(disabledDays, calendarElement) {
    if (calendarElement !== undefined) {
        const dayContainers = calendarElement.getElementsByClassName('dayContainer');
        for (let i = 0; i < dayContainers.length; i++) {
            const dayContainer = dayContainers[i];
            const flatpickrDays = dayContainer.getElementsByClassName('flatpickr-day');
            for (let r = 0; r < flatpickrDays.length; r++) {
                const flatpickrDay = flatpickrDays[r];
                if (searchDateInDates(disabledDays, flatpickrDay.dateObj)) {
                    flatpickrDay.classList.add('flatpickr-disabled', 'disabled');
                } else {
                    flatpickrDay.classList.remove('flatpickr-disabled', 'disabled');
                }
            }
        }
    }
}

function storeCachedOperative(rs, instance) {
    storedOperatives[getLocationsKey(instance.location)] = rs;
    const event = CustomEvent('activateOperative', {
        detail: {
            instance
        }
    });
    document.dispatchEvent(event);
}

function retrieveCachedOperative(instance) {
    return storedOperatives[getLocationsKey(instance.location)];
}

function getLocationsKey(locations) {
    if (locations !== undefined && locations.length > 1) {
        if (locations[0].value !== undefined && locations[1].value !== undefined && locations[1].kind !== undefined) {
            return `${locations[0].value}#${locations[1].value}#${locations[1].kind}`;
        }
    }
    return 'MAD#0#CIU';
}

function searchDateInDates(dates, date) {
    for (let i = 0; i < dates.length; i++) {
        const dateCol = dates[i];
        dateCol.setHours(0);
        if (dateCol.getTime() === date.getTime()) {
            return true;
        }
    }
    return false;
}

function getDatesBeforeTodayUntilTomorrow(calendarArray) {
    const dateTime = new Date();
    resetTimeInDate(dateTime);
    const todayDate = dateTime.getDate();
    for (let index = 1; index <= todayDate; index++) {
        dateTime.setDate(index);
        calendarArray.push(new Date(dateTime.getTime()));
    }
    dateTime.setDate(todayDate + 1);
    calendarArray.push(new Date(dateTime.getTime()));
}

function resetTimeInDate(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
}

function getDisabledDays(dates) {
    const calendarDates = [];

    for (let i = 0; i < dates.length; i++) {
        const date = dates[i];
        if (date.s >= 2) {
            const pDate = new Date(date.d);
            pDate.setHours(0);
            calendarDates.push(pDate);
        }
    }
    getDatesBeforeTodayUntilTomorrow(calendarDates);
    return calendarDates;
}

function isCalendarFirstClick(instance) {
    return instance.calendar.get().length === 1;
}

function compareDates(date, compareDate) {
    return new Date(Date.parse(date)).getTime() >= new Date(Date.parse(compareDate)).getTime();
}

function getFilteredDates(flatpickrDates, operative) {
    if (operative !== undefined) {
        const arDatesOut = operative.checkins.filter(
            date => date.s < 2 && compareDates(date.d, flatpickrDates.outboundDate)
        );
        const arDatesRet = operative.checkouts.filter(
            date => date.s < 2 && compareDates(date.d, flatpickrDates.returnDate)
        );
        return {
            arDatesOut,
            arDatesRet
        };
    }
    return {};
}

function getParsedDates(arDatesOut, arDatesRet) {
    const outboundDate = new Date(Date.parse(arDatesOut[0].d));
    const returnDate = new Date(Date.parse(arDatesRet[0].d));
    return {
        outboundDate,
        returnDate
    };
}

module.exports = {
    initCalendar,
    getLocationsKey
};
